/**
 * ครอบคำสำคัญด้วย <mark> (D20) — แยกไฟล์จาก AnswerBox เพราะ react-refresh ต้องการให้ไฟล์
 * คอมโพเนนต์ export แต่คอมโพเนนต์ · ทดสอบแยกได้ด้วย
 */
import type { ReactNode } from "react";

/**
 * ครอบคำสำคัญด้วย <mark> — ครั้งแรกที่พบของแต่ละคำ ไม่ซ้อนทับกัน
 * ทำงานบนข้อความล้วน (indexOf) ไม่ใช่ regex จึงไม่มีอักขระพิเศษให้พัง
 */
/**
 * @param render แปลงชิ้นข้อความล้วนแต่ละชิ้นก่อนใส่ลงผลลัพธ์ (D23 ใช้ `renderMath`)
 *   ค่าเริ่มต้นคือคืนสตริงเดิม — ผู้เรียกเดิมไม่เปลี่ยนพฤติกรรมแม้แต่ตัวอักษรเดียว
 */
export function markTerms(
  text: string,
  terms: readonly string[],
  render: (part: string) => ReactNode = (part) => part,
): ReactNode[] {
  const spans: Array<[number, number]> = [];
  for (const raw of terms) {
    const term = raw.trim();
    if (!term) continue;
    let from = 0;
    while (from <= text.length) {
      const at = text.indexOf(term, from);
      if (at < 0) break;
      const end = at + term.length;
      const overlaps = spans.some(([s, e]) => at < e && end > s);
      if (!overlaps) {
        spans.push([at, end]);
        break; // ครั้งแรกที่ไม่ทับกับคำอื่นเท่านั้น
      }
      from = at + 1;
    }
  }
  spans.sort((a, b) => a[0] - b[0]);
  const out: ReactNode[] = [];
  let cursor = 0;
  spans.forEach(([s, e], i) => {
    if (s > cursor) out.push(render(text.slice(cursor, s)));
    out.push(<mark key={i}>{render(text.slice(s, e))}</mark>);
    cursor = e;
  });
  if (cursor < text.length) out.push(render(text.slice(cursor)));
  return out;
}
